module.exports = require('./helpers/bundle-url').getBundleURL('hG7gn') + "logo.c51670a8.svg";